import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { GoogleService } from 'src/app/services/auth/google/google.service';
import { LinkedinService } from 'src/app/services/auth/linkedin/linkedin.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword = false;
  email: string = '';
  password: string = '';
  constructor( private linkedIn: LinkedinService, private google: GoogleService, private authService: AuthService, private userService: UserService, private loader: LoadingService) {}

  loginAsUser() {
    const user = {
      email: this.email,
      sub: this.password
    }
    this.loader.showLoading();
    this.authService.loginAsUser(user).subscribe((response: any) => {
      this.loader.hideLoading();
      this.userService.setTokenInfo(response.accessToken, response.refreshToken, response.userId, response.role);
      window.location.href = '/';
    }, (error) => {
      this.loader.hideLoading();
    });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  loginWithLinkedIn() {
    this.linkedIn.loginWithLinkedIn();
  }

  loginWithGoogle() {
    this.google.login();
  }
}
